module.exports = __webpack_public_path__ + "img/left-chevron.d413bfac.svg";